import { Layout, LayoutAxis, Legend, Shape } from "plotly.js";
import {
  BarChartData,
  BarChartLayout,
  BarChartLegend,
  BarChartShape,
  BarChartXAxis,
  BarChartYAxis,
} from "./barChartInterface";

import { isDefined } from "Utils/functions";
import { DEFAULT_CHART_FONT } from "../chartConfig";

export const getBarChartData = (data: BarChartData[]): BarChartData[] =>
  data.map((instance) =>
    instance.mode === "markers"
      ? instance
      : {
          ...instance,
          type: "bar",
        },
  );

export const getBarChartLayout = (
  layout: BarChartLayout,
  isStackedBarChart: boolean,
): Partial<Layout> => {
  const { title, size, xAxis, yAxis, shapes, annotations, legend } = layout;
  return {
    barmode: isStackedBarChart ? "stack" : undefined,
    title: {
      font: {
        size: 16,
      },
      text: `<b>${title}</b>`,
    },
    font: {
      family: DEFAULT_CHART_FONT,
    },
    height: size.height,
    width: size.width,
    showlegend: isDefined(legend),
    legend: isDefined(legend) ? mapLegend(legend) : undefined,
    xaxis: mapXAxis(xAxis),
    yaxis: mapYAxis(yAxis),
    annotations,
    shapes: mapShapes(shapes),
    dragmode: false,
  };
};

export const mapLegend = (legendData: BarChartLegend): Partial<Legend> => ({
  font: { size: 14 },
  yanchor: "top",
  orientation: legendData.orientation,
  y: legendData.y,
});

export const mapYAxis = ({
  title,
  ...rest
}: BarChartYAxis): Partial<LayoutAxis> => ({
  title: {
    text: title,
    standoff: 15,
    font: { size: 14 },
  },
  ...rest,
});

export const mapXAxis = (xAxisData: BarChartXAxis): Partial<LayoutAxis> => ({
  title: {
    text: xAxisData.title,
    standoff: 20,
    font: { size: 14 },
  },
  type: xAxisData.type,
  automargin: true,
});

export const mapShapes = (
  shapeData?: BarChartShape[],
): Partial<Shape>[] | [] => {
  if (isDefined(shapeData)) {
    return shapeData.map((shape) => ({
      type: shape.type,
      xref: shape.xref,
      yref: shape.yref,
      line: shape.line,
      x0: shape.x.start,
      x1: shape.x.end,
      y0: shape.y.start,
      y1: shape.y.end,
      opacity: 0.4,
    }));
  }
  return [];
};
